module.exports = __webpack_public_path__ + "static/img/20210315162550.677f931.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/inspectionImg/20210315/20210315162550.jpg
// module id = uxON
// module chunks = 11